
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intents/rockflow",
      function () {
        return require("private-next-pages/intents/rockflow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intents/rockflow"])
      });
    }
  